import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { UserModel, SysconfigModel } from './../models/user.model';
import { StorageService } from './../providers/storage.service';
import * as moment from 'moment';
import { List } from 'linqts';
import { AppConfig } from "./../app/app.config";

const enum colors {
    red,
    green,
    blue,
}

@Injectable()
export class BettingOrderHelper {
    sysconfig: SysconfigModel = new SysconfigModel();
    currUser: UserModel = new UserModel()

    constructor(
        private storage: StorageService
    ) {
        this.sysconfig = this.storage.read<SysconfigModel>("sysconfig");
        this.currUser = this.storage.read<UserModel>("User");
    }




    getBanboNumberList(playDetailName) {
        let outNum = 49; //半波排除 49
        let middleNum = 25; // 判断号码大小的数 大于等于25为大  小于 25为小
        let numberArr = [];
        let colorArr = ["red", "green", "blue"];
        let listMarkSixNumbers = this.getNumberInfoArr();
        //排除49这个特码
        listMarkSixNumbers = listMarkSixNumbers.filter((obj) => {
            return obj.num != 49;
        });
        listMarkSixNumbers.filter((item) => {
            if (playDetailName == "红单") {
                if (item.color == colorArr[colors.red] && this.isEvenOrOdd(item.num)) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "红双") {
                if (item.color == colorArr[colors.red] && !this.isEvenOrOdd(item.num) && item.num != outNum) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "红大") {
                if (item.color == colorArr[colors.red] && item.num >= middleNum) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "红小") {
                if (item.color == colorArr[colors.red] && item.num < middleNum) {
                    numberArr.push(item.num);
                }
            }

            if (playDetailName == "绿单") {
                if (item.color == colorArr[colors.green] && this.isEvenOrOdd(item.num)) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "绿双") {
                if (item.color == colorArr[colors.green] && !this.isEvenOrOdd(item.num)) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "绿大") {
                if (item.color == colorArr[colors.green] && item.num >= middleNum) {
                    numberArr.push(item.num);
                }
            }
            if (playDetailName == "绿小") {
                if (item.color == colorArr[colors.green] && item.num < middleNum) {
                    numberArr.push(item.num);
                }
            }

            if (playDetailName == "蓝单") {
                if (item.color == colorArr[colors.blue] && this.isEvenOrOdd(item.num)) {
                    numberArr.push(item.num);
                }
            }

            if (playDetailName == "蓝双") {
                if (item.color == colorArr[colors.blue] && !this.isEvenOrOdd(item.num)) {
                    numberArr.push(item.num);
                }
            }

            if (playDetailName == "蓝大") {
                if (item.color == colorArr[colors.blue] && item.num >= middleNum) {
                    numberArr.push(item.num);
                }
            }

            if (playDetailName == "蓝小") {
                if (item.color == colorArr[colors.blue] && item.num < middleNum) {
                    numberArr.push(item.num);
                }
            }


            if (playDetailName == "红合单") {
                if (item.color == colorArr[colors.red]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
            if (playDetailName == "红合双") {
                if (item.color == colorArr[colors.red]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (!this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
            if (playDetailName == "绿合单") {
                if (item.color == colorArr[colors.green]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
            if (playDetailName == "绿合双") {
                if (item.color == colorArr[colors.green]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (!this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
            if (playDetailName == "蓝合单") {
                if (item.color == colorArr[colors.blue]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
            if (playDetailName == "蓝合双") {
                if (item.color == colorArr[colors.blue]) {
                    this.getNumberSum(item.num, (sumNum, number) => {
                        if (!this.isEvenOrOdd(sumNum))
                            numberArr.push(number);
                    })
                }
            }
        });
        return numberArr;
    }

    getNumberSum(number, callback) {
        let tempNum = (number + "");
        let sumNum = 0;
        for (let i = 0; i < (number + "").length; i++) {
            sumNum += parseInt(tempNum[i])
        }
        callback(sumNum, number);
    }


    /**
     * 是否奇数/
     * true 表示是奇数 false表示偶数
     * @param {*} num 传入的数字
     * @memberof BettingOrderHelper
     */
    isEvenOrOdd(num): boolean {
        if (/\d/.test(num) && num % 2 == 1)
            return true;
        return false;
    }



    /**
     * 根据生肖或者尾数数字获取对应的号码
     * evan 2018-07-25
     * @param {*} value 传入的生肖或者数字
     * @memberof BettingOrderHelper
     */
    getNumberByZodiacOrLastWord(value) {
        let listMarkSixNumbers = this.getNumberInfoArr();
        let numArr = [];
        if (isNaN(value)) {
            if (value.indexOf("尾") >= 0) {
                let indexOfString = value.substr(0, 1);
                listMarkSixNumbers.filter((item) => {
                    if ((item.num + "").lastIndexOf(indexOfString) == ((item.num + "").length - 1))
                        numArr.push(item.num);
                });
            }
            else {
                listMarkSixNumbers.filter((item) => {
                    if (item.zodiac == value)
                        numArr.push(item.num);
                });
            }
        }
        else {
            listMarkSixNumbers.filter((item) => {
                if ((item.num + "").lastIndexOf(value) === ((item.num + "").length - 1))
                    numArr.push(item.num);
            });
        }
        return numArr;
    }


    /**
     * 获取六合彩号码对应的生肖和颜色并返回一个数组
     * evan 2018-07-25
     * @returns  listMarkSixNumbers 六合彩号码对应的生肖和颜色的数组
     * @memberof BettingOrderHelper
     */
    getNumberInfoArr() {
        let year = AppConfig.lhcYear;
        let k = 1;
        let listMarkSixNumbers = [];
        for (var m = year; m >= (year - 48); m--) {
            let zodiacAndPoultry = this.getZodiacAndPoultryByYean(m);
            if (zodiacAndPoultry) {
                let numberInfo = {
                    num: k,
                    color: this.getLetteryMarkSixColor(k).color,
                    zodiac: zodiacAndPoultry.zodiac,
                    isPoultry: zodiacAndPoultry.isPoultry,
                }
                listMarkSixNumbers.push(numberInfo);
                k += 1;
            }
        }
        return listMarkSixNumbers;
    }

    /**
     * 六合彩号码对应的色波和生肖
     * evan 2018-07-11
     * @param number 传入的数字
     */
    getLetteryMarkSixColor(number) {
        let numberAttr = {
            "1": { color: "red" },
            "2": { color: "red" },
            "3": { color: "blue" },
            "4": { color: "blue" },
            "5": { color: "green" },
            "6": { color: "green" },
            "7": { color: "red" },
            "8": { color: "red" },
            "9": { color: "blue" },
            "10": { color: "blue" },
            "11": { color: "green" },
            "12": { color: "red" },
            "13": { color: "red" },
            "14": { color: "blue" },
            "15": { color: "blue" },
            "16": { color: "green" },
            "17": { color: "green" },
            "18": { color: "red" },
            "19": { color: "red" },
            "20": { color: "blue" },
            "21": { color: "green" },
            "22": { color: "green" },
            "23": { color: "red" },
            "24": { color: "red" },
            "25": { color: "blue" },
            "26": { color: "blue" },
            "27": { color: "green" },
            "28": { color: "green" },
            "29": { color: "red" },
            "30": { color: "red" },
            "31": { color: "blue" },
            "32": { color: "green" },
            "33": { color: "green" },
            "34": { color: "red" },
            "35": { color: "red" },
            "36": { color: "blue" },
            "37": { color: "blue" },
            "38": { color: "green" },
            "39": { color: "green" },
            "40": { color: "red" },
            "41": { color: "blue" },
            "42": { color: "blue" },
            "43": { color: "green" },
            "44": { color: "green" },
            "45": { color: "red" },
            "46": { color: "red" },
            "47": { color: "blue" },
            "48": { color: "blue" },
            "49": { color: "green" }
        }
        return numberAttr[number];
    }

    // getZodiacAndPoultry(index) {

    //     return zodiacArr[index];
    // }

    /**
     * 根据传入的年份获取对应的生肖信息
     * evan 2018-07-11
     * @param {number} year
     * @returns
     * @memberof BettingOrderHelper
     */
    getZodiacAndPoultryByYean(year: number) {
        let zodiacArr = [
            { zodiac: "鼠", isPoultry: false },
            { zodiac: "牛", isPoultry: true },
            { zodiac: "虎", isPoultry: false },
            { zodiac: "兔", isPoultry: false },
            { zodiac: "龙", isPoultry: false },
            { zodiac: "蛇", isPoultry: false },
            { zodiac: "马", isPoultry: true },
            { zodiac: "羊", isPoultry: true },
            { zodiac: "猴", isPoultry: false },
            { zodiac: "鸡", isPoultry: true },
            { zodiac: "狗", isPoultry: true },
            { zodiac: "猪", isPoultry: true }
        ]
        //以鼠为开头所以，年份默认一个鼠年的年份 eg 1960年
        let zodiac = zodiacArr[((year - 1960) % 12)];
        return zodiac;
    }

    getMedianList(algorithmCode, algorithmTypeCode) {
        var medianlist;
        if (algorithmTypeCode == "0101"
            || algorithmTypeCode == "0112"
            || algorithmTypeCode == "0109"
            || algorithmTypeCode == "0113"
            || algorithmTypeCode == "ZH5"
            || algorithmTypeCode == "ZH4"
            || algorithmTypeCode == "ZH3"
            || algorithmTypeCode == "RXZXFS"
        ) {
            medianlist = ["万位", "千位", "百位", "十位", "个位"];
        } else if (algorithmTypeCode == "0110" || algorithmTypeCode == "ZU2FS") {
            medianlist = ["组二"];
        } else if (algorithmTypeCode == "0103"
            || algorithmTypeCode == "0305") {
            medianlist = ["组三"];
        } else if (algorithmTypeCode == "0104"
            || algorithmTypeCode == "0306") {
            medianlist = ["组六"];
        } else if (algorithmTypeCode == "0107"
            || algorithmTypeCode == "0308") {
            medianlist = ["直选"];
        } else if (algorithmTypeCode == "ZUHZ2") {
            medianlist = ["和值"];
        } else if (algorithmTypeCode == "ZXKD") {
            medianlist = ["跨度"];
        } else if (algorithmTypeCode == "ZUBD") {
            medianlist = ["包胆"];
        } else if (algorithmTypeCode == "YFFS") {
            medianlist = ["一帆风顺"];
        } else if (algorithmTypeCode == "HSCS") {
            medianlist = ["好事成双"];
        } else if (algorithmTypeCode == "SXBX") {
            medianlist = ["三星报喜"];
        } else if (algorithmTypeCode == "SJFC") {
            medianlist = ["四季发财"];
        } else if (algorithmTypeCode == "HZWS") {
            medianlist = ["和值尾数"];
        } else if (algorithmTypeCode == "TSH") {
            medianlist = ["特殊号"];
        } else if (algorithmTypeCode == "0108"
            || algorithmTypeCode == "0309") {
            medianlist = ["组选"];
        } else if (algorithmTypeCode == "0106" || algorithmTypeCode == "BDW1" || algorithmTypeCode == "BDW2" || algorithmTypeCode == "0312") {
            medianlist = ["不定位"];
        } else if (algorithmTypeCode == "0201" || algorithmTypeCode == "HQRX" || algorithmTypeCode == "LQRX" || algorithmTypeCode == "RX1" || algorithmTypeCode == "HQRX35" || algorithmTypeCode == "RX") {
            medianlist = ["任选"];
        } else if (algorithmCode == "02024") {
            medianlist = ["任一"];
        } else if (algorithmCode === "02001") {
            medianlist = ["任二"];
        } else if (algorithmCode == "02007") {
            medianlist = ["任五"];
        } else if (algorithmCode == "02009") {
            medianlist = ["任六"];
        } else if (algorithmCode == "02011") {
            medianlist = ["任七"];
        } else if (algorithmCode == "02013") {
            medianlist = ["任八"];
        } else if (algorithmTypeCode === "0203") {
            medianlist = ["一位", "二位", "三位"];
        } else if (algorithmTypeCode === "0204") {
            medianlist = ["一位", "二位", "三位", "四位", "五位"];
        } else if (algorithmTypeCode == "0206" && algorithmCode == "02020") {
            medianlist = ["组选"];
        } else if (algorithmTypeCode == "0206" && algorithmCode == "02022") {
            medianlist = ["组选"];
        } else if (algorithmTypeCode == "0310") {
            medianlist = ["不定位"];
        } else if (algorithmTypeCode == "0311"
            || algorithmTypeCode == "0301"
            || algorithmTypeCode == "0303"
            || algorithmTypeCode === "DXDS") {
            medianlist = ["百位", "十位", "个位"];
        } else if (algorithmCode == "04001") {
            medianlist = ["数投"];
        } else if (algorithmCode == "04002") {
            medianlist = ["红投"];
        } else if (algorithmCode == "04003") {
            medianlist = ["一位", "二位"];
        } else if (algorithmCode == "04004") {
            medianlist = ["组选"];
        } else if (algorithmCode == "04005") {
            medianlist = ["一位", "二位", "三位"];
        } else if (algorithmCode == "04007") {
            medianlist = ["组选"];
        } else if (algorithmCode == "04008") {
            medianlist = ["任二"];
        } else if (algorithmCode == "04009") {
            medianlist = ["任三"];
        } else if (algorithmCode == "04010") {
            medianlist = ["任四"];
        } else if (algorithmCode == "04011") {
            medianlist = ["任五"];
        } else if (algorithmCode == "07001"
            || algorithmTypeCode == "bth3hz") {
            medianlist = ["和值"];
        } else if (algorithmCode == "07002") {
            medianlist = ["三同号"];
        } else if (algorithmCode == "07003") {
            medianlist = ["三同号"];
        } else if (algorithmCode == "07004") {
            medianlist = ["二同号"];
        } else if (algorithmCode == "07005") {
            medianlist = ["二同号", "不同号"];
        } else if (algorithmCode == "07006") {
            medianlist = ["三不同"];
        } else if (algorithmCode == "07007") {
            medianlist = ["二不同"];
        } else if (algorithmCode == "07008") {
            medianlist = ["三连号"];
        } else if (algorithmTypeCode == "WXZU120") {
            medianlist = ["组选120"];
        } else if (algorithmTypeCode == "WXZU60" || algorithmTypeCode == "WXZU30" || algorithmTypeCode == "SXZU12") {
            medianlist = ["二重号", "单 号"];
        } else if (algorithmTypeCode == "WXZU20" || algorithmTypeCode == "SXZU4") {
            medianlist = ["三重号", "单号"];
        } else if (algorithmTypeCode == "WXZU10") {
            medianlist = ["三重号", "二重号"];
        } else if (algorithmTypeCode == "WXZU5") {
            medianlist = ["四重号", "单号"];
        } else if (algorithmTypeCode == "SXZU24") {
            medianlist = ["组选24"];
        } else if (algorithmTypeCode == "SXZU6") {
            medianlist = ["二重号"];
        } else if (algorithmTypeCode === "0208") {
            medianlist = ["前三位"];
        } else if (algorithmTypeCode == "DT" || algorithmTypeCode == "RXDT" || algorithmTypeCode == "bthdt") {
            medianlist = ["胆码", "拖码"];
        } else if (algorithmTypeCode == "DDS") {
            medianlist = ["定单双"];
        } else if (algorithmTypeCode == "CZW") {
            medianlist = ["猜中位"];
        } else if (algorithmTypeCode === "PK10CGJ") {
            medianlist = ["冠军"];
        } else if (algorithmTypeCode === "PK10GYJ") {
            medianlist = ["冠军", "亚军"];
        } else if (algorithmTypeCode === "PK10QSM") {
            medianlist = ["冠军", "亚军", "季军"];
        } else if (algorithmTypeCode === "PK10Four") {
            medianlist = ["第1名", "第2名", "第3名", "第4名"];
        } else if (algorithmTypeCode === "PK10Five") {
            medianlist = ["第1名", "第2名", "第3名", "第4名", "第5名"];
        } else if (algorithmTypeCode === "PK10QDWD1") {
            medianlist = ["第1名", "第2名", "第3名", "第4名", "第5名"];
        } else if (algorithmTypeCode === "PK10QDWD2") {
            medianlist = ["第6名", "第7名", "第8名", "第9名", "第10名"];
        } else if (algorithmTypeCode === "PK10DX") {
            medianlist = ["第一名", "第二名", "第三名"];
        } else if (algorithmTypeCode === "PK10DS") {
            medianlist = ["第一名", "第二名", "第三名"];
        } else if (algorithmTypeCode == "LONGHU") {
            medianlist = ["龙虎和", "和值"];
        } else if (algorithmTypeCode == "NEWLONGHU") {
            medianlist = ["龙虎"];
        } else if (algorithmTypeCode == "HQDWD") {
            medianlist = ["第一位", "第二位", "第三位", "第四位", "第五位", "第六位"];
        }

        return medianlist;
    };


    getCommandList(algorithmTypeCode) {
        var commandlist = new Array();
        switch (algorithmTypeCode) {
            case "0701":
            case "0702":
            case "0705":
            case "0708":
            case "DDS":
            case "ZUBD":
                break;
            case "PK10DX":
            case "PK10DS":
            case "LONGHU":
                commandlist = ["全", "清"];
                break;
            case "NEWLONGHU":
                commandlist = ["全", "清"];
                break;
            case "0109":
            case "DXDS":
            case "TSH":
                commandlist = ["清"];
                break;
            default:
                commandlist = ["全", "大", "小", "单", "双", "清"];
                break;
        }
        return commandlist;
    };

    getNumList(algorithmTypeCode, betNumLength, lotteryCode) {
        var numlist;
        var i;
        switch (algorithmTypeCode) {
            case "":
                break;
            case "0107":
            case "0308":
                numlist = [];
                for (i = 0; i <= 9 * betNumLength; i++) {
                    numlist.push(i + "");
                }
                break;
            case "0108":
            case "0309":
            case "ZUHZ2":
                numlist = [];
                for (i = 1; i <= 9 * betNumLength - 1; i++) {
                    numlist.push(i + "");
                }
                break;
            case "0109":
            case "DXDS":
                numlist = (["大", "小", "单", "双"]);
                break;
            case "0201":
            case "0203":
            case "0204":
            case "0206":
            case "0208":
            case "DT":
            case "RXDT":
                numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"]);
                break;
            case "0401":
                numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18"]);
                break;
            case "0403":
            case "0404":
            case "0405":
            case "0406":
            case "0407":
            case "0408":
                numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"]);
                break;
            case "0402":
                numlist = (["19", "20"]);
                break;
            case "0701":
                numlist = (["3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18"]);
                break;
            case "0702":
            case "0708":
                numlist = ["通选"];
                break;
            case "0703":
                numlist = (["111", "222", "333", "444", "555", "666"]);
                break;
            case "0704":
                numlist = (["11", "22", "33", "44", "55", "66"]);
                break;
            case "0705":
                numlist = [["11", "22", "33", "44", "55", "66"], ["1", "2", "3", "4", "5", "6"]];
                break;
            case "0706":
            case "bthdt":
                numlist = (["1", "2", "3", "4", "5", "6"]);
                break;
            case "0707":
                numlist = (["1", "2", "3", "4", "5", "6"]);
                break;
            case "TSH":
                numlist = ["豹子", "顺子", "对子"];
                break;
            case "CZW":
                numlist = ["03", "04", "05", "06", "07", "08", "09"];
                break;
            case "DDS":
                numlist = ["5单0双", "4单1双", "3单2双", "2单3双", "1单4双", "0单5双"];
                break;
            case "bth3hz":
                numlist = ["6", "7", "8", "9", "10", "11", "12", "13", "14", "15"];
                break;
            case "PK10CGJ":
            case "PK10GYJ":
            case "PK10QSM":
            case "PK10QDWD1":
            case "PK10QDWD2":
            case "PK10Four":
            case "PK10Five":
                numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"]);
                break;
            case "PK10DX":
                numlist = ["大", "小"];
                break;
            case "PK10DS":
                numlist = ["单", "双"];
                break;
            case "LONGHU":
                numlist = [["龙", "虎", "和"], ["大", "小", "单", "双"]];
                break;
            case "NEWLONGHU":
                numlist = [["龙", "虎"]];
                break;
            case "HQRX":
                switch (lotteryCode) {
                    case '30012': // 双色球
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33"]);
                        break;
                    case '30014': // 七乐彩
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"]);
                        break;
                    case '30015': // 大乐透
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35",]);
                        break;
                }
                break;
            case "LQRX":
                switch (lotteryCode) {
                    case '30012':
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16"]);
                        break;
                    case '30014':
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"]);
                        break;
                    case '30016': // 七星彩
                        numlist = (["0", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14"]);
                        break;
                    case '30015': // 大乐透
                        numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]);
                        break;
                }
                break;
            case "RX": //快乐8
                numlist = (["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80"]);
                break;
            default:
                numlist = (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]);
                break;
        }
        return numlist;
    };

    getCheckName(lotteryType, isrx) {
        var checklist = new Array();
        if (isrx) {
            if (lotteryType == "01") {
                checklist = ["万位", "千位", "百位", "十位", "个位"];
            } else if (lotteryType == "02") {
                checklist = ["一位", "二位", "三位", "四位", "五位"];
            } else if (lotteryType == "03") {
                checklist = ["百位", "十位", "个位"];
            } else if (lotteryType == "04") {

            } else if (lotteryType == "06") {

            } else if (lotteryType == "07") {

            } else if (lotteryType == "08") {
                checklist = ["第1名", "第2名", "第3名", "第4名", "第5名", "第6名", "第7名", "第8名", "第9名", "第10名"];
            }
        }
        return checklist;
    };

    getCurrentLotteryBetCount(par) {
        //dataSel, lotteryTypeCode, checklist, algorithmTypeCode, betNumLength, isrx 
        var checkedlength = 0; var isrxindex = 0;
        if (par.isrx) {
            isrxindex = 1;
            for (var i = 0; i < par.checklist.length; i++) {
                if (par.checklist[i].checked) {
                    checkedlength++;
                }
            }
        } else {
            isrxindex = 0;
        }

        if (par.lotteryTypeCode == ("01") || par.algorithmTypeCode == "HQDWD") {
            return this.GetSSCLotteryBetCount(par.dataSel, checkedlength, par.algorithmTypeCode, par.betNumLength, isrxindex);
        }
        else if (par.lotteryTypeCode == ("02")) {
            return this.Get5in11BetCount(par.dataSel, checkedlength, par.algorithmTypeCode, par.betNumLength);
        }
        else if (par.lotteryTypeCode == ("03") && par.algorithmTypeCode != "HQDWD") {
            return this.GetLowFrequencyBetCount(par.dataSel, checkedlength, par.algorithmTypeCode, par.betNumLength);
        }
        // else if (lotteryTypeCode == ("04")) {
        //     return this.GetHappyTenBetCount(dataSel, checkedlength, algorithmTypeCode, betNumLength);
        // }
        else if (par.lotteryTypeCode == ("07")) {
            return this.GetKuai3BetCount(par.dataSel, checkedlength, par.algorithmTypeCode, par.betNumLength);
        } else if (par.lotteryTypeCode === "08") {
            return this.GetPk10BetCount(par.dataSel, checkedlength, par.algorithmTypeCode, par.betNumLength);
        }
    };

    getLotteryNum(data, algorithmTypeCode) {
        var varBuilder = new Array();
        for (var i in data) {
            var v = data[i];
            switch (algorithmTypeCode) {
                case "0106":
                case "BDW1":
                case "BDW2":
                case "0107":
                case "0108":
                case "0201":
                case "0202":
                case "0308":
                case "0309":
                case "0701":
                case "WXZU120":
                case "SXZU24":
                case "ZUHZ2":
                case "TSH":
                case "YFFS":
                case "HSCS":
                case "SXBX":
                case "SJFC":
                case "HZWS":
                case "ZUBD":
                case "ZXKD":
                case "DDS":
                case "CZW":
                case "ZU2FS":
                case "0703":
                case "0706":
                case "0704":
                case "0707":
                case "bth3hz":
                case "RX":
                case "HQRX":
                case "LQRX":
                case "RX1":
                case "HQRX35":
                    varBuilder.push(v.join(','));
                    break;
                case "0112":
                case "0203":
                case "0311":
                case "HQDWD":
                    if (v.length == 0) {
                        varBuilder.push('-');
                    } else {
                        varBuilder.push(v.join(''));
                    }
                    break;
                case "0705":
                    if (parseInt(i) === 0) {
                        let tmp = [];
                        v.forEach(s => {
                            tmp.push(s.substr(0, 1));
                        });
                        v = tmp;
                    }
                    varBuilder.push(v.join(''));
                    break;
                default:
                    varBuilder.push(v.join(''));
                    break;
            }
        }
        return varBuilder.join(',');
    };

    getSelectMedian(type, checkList, lotteryTypeCode) {
        var selectMedian = "";
        var medianlist = [];

        if (type == ("name")) {

            if (checkList.length > 0) {
                // app.tools.where($scope.checkList, { checked: true }, function (v, i) {
                //     medianlist.push(v.name);
                // });
                checkList.find(s => s.checked).forEach(v => {
                    medianlist.push(v.name);
                });

            }
            selectMedian = medianlist.join('、');
        }

        if (type == ("code")) {
            if (checkList.length == 0) {
                if (lotteryTypeCode == ("01")) {
                    selectMedian = "11111";
                }
                else if (lotteryTypeCode == ("02")) {
                    selectMedian = "11111";
                }
                else if (lotteryTypeCode == ("03")) {
                    selectMedian = "111";
                }
                else if (lotteryTypeCode == "07") {
                    selectMedian = "111";
                } else if (lotteryTypeCode === "08") {
                    selectMedian = "1111111111";
                }
            }
            if (checkList.length > 0) {
                for (var i = 0; i < checkList.length; i++) {
                    if (checkList[i].checked) {
                        medianlist.push("1");
                    } else {
                        medianlist.push("0");
                    }
                }
                selectMedian = medianlist.join('');
            }
        }


        return selectMedian;
    }

    getNextIssueNoList(issue, nowIssueNo, count) {
        var list;
        var j;
        if (issue.LotteryCode === "10011" || issue.LotteryCode === "10012" || issue.LotteryCode === "10013" ||
            issue.LotteryCode === "10014" || issue.LotteryCode === "80001" || issue.LotteryCode === "10015" || issue.LotteryCode === "30010" ||
            issue.LotteryCode === "10020" || issue.LotteryCode === "50001" || issue.LotteryCode === "95000" || issue.LotteryCode === "80006" ||
            issue.LotteryCode === "30012" || issue.LotteryCode === "30013" || issue.LotteryCode === "30014" || issue.LotteryCode === "30015" || 
            issue.LotteryCode === "30016"
        ) {
            list = new Array();
            for (j = 0; j < count; j++) {
                list.push((parseInt(nowIssueNo, 10) + j) + "");
            }
            return list;
        }

        if (issue.LotteryCode !== '30001' && issue.LotteryCode !== '30002' && issue.LotteryCode !== '30011' && issue.LotteryCode !== '10081') {
            list = new Array();
            var isMaxIssueOn = false;
            var tIssueNo = 0;
            for (var i = 0; i < count; i++) {
                var thisIssueNo = parseInt(issue.IssueNo, 10) + i - (tIssueNo * issue.MaxIssue);
                var nowIssueDay = moment(issue.NowIssueDay);
                nowIssueDay = nowIssueDay.add(tIssueNo, 'day');
                var len = (issue.MaxIssue + "").length;
                if (thisIssueNo < 1000 && len > 3) {
                    len = 3;
                }
                if (issue.LotteryCode == "10004" || issue.LotteryTypeCode == "07" || issue.LotteryCode == "10003" ||
                    issue.LotteryCode == "10001") {
                    len = 3;
                }
                var tt = nowIssueDay.format("YYYYMMDD") + this.getStringPadLeft(thisIssueNo.toString(), len, "0");
                list.push(tt);
                if (thisIssueNo === issue.MaxIssue) {
                    isMaxIssueOn = true;
                    tIssueNo++;
                } else {
                    isMaxIssueOn = false;
                }
            }
        } else {
            list = new Array();
            for (j = 0; j < count; j++) {
                list.push((parseInt(nowIssueNo, 10) + j) + "");
            }
        }

        return list;
    };

    validateBettingNumber(value, lotteryTypeCode, playDetail) {
        var bettingCount = 0;
        var inputstr = value;
        var betNumLength = playDetail.Algorithm.BetNumLength;
        var algorithmTypeCode = playDetail.Algorithm.AlgorithmTypeCode;
        var algorithmCode = playDetail.Algorithm.AlgorithmCode;
        var numlist = [];
        var numindex;
        var num;
        var numarray;
        var j;
        var stop;
        var i;
        if (lotteryTypeCode === "02" || lotteryTypeCode === "08") {
            var splitArr = inputstr.split(/\n|;|,/);
            numlist = [];
            numlist = splitArr || [].find(s => !s);

            bettingCount = 0;
            for (numindex = 0; numindex < numlist.length; numindex++) {
                num = numlist[numindex];
                if (num) {
                    stop = false;
                    numarray = numlist[numindex].trim().split(" ");
                    if (numarray.length != betNumLength && numindex < numlist.length - 1) {
                        continue;
                    }
                    for (var k = 0; k < numarray.length; k++) {
                        var n = numarray[k];
                        if (n.length != 2 || (parseInt(n) > 11 || parseInt(n) < 1)) {
                            stop = true;
                            break;
                        }
                    }
                    if (stop)
                        continue;
                    if (numindex == numlist.length - 1) {
                        if (numarray.length < betNumLength) {
                            return bettingCount;
                        }
                        if (numarray.length > betNumLength) {
                            continue;
                        }
                    }

                    for (i = 0; i < numarray.length - 1; i++) {
                        for (j = i + 1; j < numarray.length; j++) {
                            if (numarray[i] == (numarray[j])) {
                                stop = true;
                                break;
                            }
                        }
                        if (stop) {
                            break;
                        }
                    }
                    if (stop) {
                        continue;
                    }
                    bettingCount++;
                }
            }
        }
        else if (lotteryTypeCode == ("04")) {
            numlist = inputstr.replaceAll(" ", "").replaceAll("　", "").split(/[^\d]+/g);
            numindex = 0;
            bettingCount = 0;
            for (numindex = 0; numindex < numlist.length; numindex++) {
                if (numlist[numindex]) {
                    stop = false;
                    numindex++;
                    num = numlist[numindex];
                    if (num < 0) {
                        continue;
                    }

                    if (algorithmCode == ("04006")) {
                        if (numlist[numindex].length != betNumLength * 2 && numindex < numlist.length - 1) {
                            continue;
                        }
                        if (numindex == numlist.length - 1) {
                            if (numlist[numindex].length < betNumLength * 2) {
                            }
                            if (numlist[numindex].length > betNumLength * 2) {
                                continue;
                            }
                        }
                        //numarray = fn.SplitLength(numlist[numindex], 2);
                        numarray = numlist[numindex].splitLength(2);
                        for (i = 0; i < numarray.length - 1; i++) {
                            for (j = i + 1; j < numarray.length; j++) {
                                if (numarray[i] == (numarray[j])) {
                                    stop = true;
                                }
                            }
                            if (stop) {
                                break;
                            }
                        }
                        if (stop) {
                            continue;
                        }
                        numarray.forEach(s => {
                            if (n.length == 2 && (n > 20 || n < 1)) {
                                stop = true;
                                return false;
                            }
                        });
                        if (stop) {
                            continue;
                        }
                    }
                    bettingCount++;
                }
            }
        }
        else if (lotteryTypeCode == "07") {
            numlist = inputstr.split(/[^\d]/g);
            var len = numlist.length;
            for (i = 0; i < len; i++) {
                num = numlist[i];
                var regex = new RegExp('^[0-6]{' + betNumLength + '}$');
                if (!regex.test(num)) {
                    continue;
                }
                var first;
                var second;
                var third;
                if (algorithmTypeCode === "bth2ds") {
                    if (num.length !== 2) {
                        continue;
                    }
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    if (first === second) continue;
                } else if (algorithmTypeCode === "bth3ds") {
                    if (num.length !== 3) continue;
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    third = num.substring(2, 3);
                    if (first === second || second === third || third === first) continue;
                } else if (algorithmTypeCode === "th2dxds") {
                    if (num.length !== 3) {
                        continue;
                    }
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    third = num.substring(2, 3);
                    if (first !== second && first !== third && second !== third) continue;
                }

                bettingCount++;
            }
        }
        else {
            numlist = inputstr.split(/[^\d]+/g);
            numindex = 0;
            bettingCount = 0;
            for (numindex = 0; numindex < numlist.length; numindex++) {
                if (numlist[numindex]) {
                    num = numlist[numindex];
                    if (num < 0) {
                        continue;
                    }

                    if (num.length != betNumLength && numindex < numlist.length - 1) {
                        continue;
                    }
                    if (numindex == numlist.length - 1) {
                        if (num.length < betNumLength) {
                            continue;
                        }
                        if (num.length > betNumLength) {
                            continue;
                        }
                    }

                    numarray = this.SplitLength(num, 1);//num.splitLength(1);
                    if ((algorithmTypeCode == ("ZU3DS") && num.length == 3)
                        || (algorithmTypeCode == ("0313") && num.length == 3)) {
                        if ((numarray[0] != (numarray[1]) && numarray[0] != (numarray[2]) && numarray[1] != numarray[2])
                            || (numarray[0] == numarray[1] && numarray[0] == numarray[2])) {
                            continue;
                        }
                    } else if ((algorithmTypeCode == ("ZU6DS") && num.length == 3)
                        || (algorithmTypeCode == ("0314") && num.length == 3)) {
                        if (!(numarray[0] != numarray[1] && numarray[0] != numarray[2] && numarray[1] != numarray[2])) {
                            continue;
                        }
                    } else if ((algorithmTypeCode == ("0105") && num.length == 3)
                        || (algorithmTypeCode == ("0307") && num.length == 3)) {
                        if (numarray[0] == numarray[1] && numarray[0] == numarray[2]) {
                            continue;
                        }
                    } else if ((algorithmTypeCode == ("0111") && num.length == 2)
                        || (algorithmTypeCode == ("ZU2DS") && num.length == 2)) {
                        if (numarray[0] == numarray[1]) {
                            continue;
                        }

                    }

                    if (algorithmTypeCode == ("03002")
                        || algorithmTypeCode == ("03004")
                        || algorithmTypeCode == ("03007")) {
                        if (numlist[numindex].length != betNumLength && numindex < numlist.length - 1) {
                            continue;
                        }
                        if (numindex == numlist.length - 1) {
                            if (numlist[numindex].length < betNumLength) {
                                continue;
                            }
                            if (numlist[numindex].length > betNumLength) {
                                continue;
                            }
                        }
                        if (playDetail.AlgorithmCode == ("03007")) {
                            numarray = this.SplitLength(numlist[numindex], 1);//numlist[numindex].splitLength(1);
                            if (numarray[0] == (numarray[1]) && numarray[0] == (numarray[2])) {
                                //throw new Error(String.format("第{0}个不是组三或组六的号码.", numindex));
                                continue;
                            }
                        }
                    }

                    if (algorithmTypeCode === 'bth2ds') {
                        if (numarray[0] == numarray[1]) {
                            continue;
                        }
                    } else if (algorithmTypeCode === 'th2dxds') {
                        if ((numarray[0] === numarray[1] && numarray[0] === numarray[2] && numarray[1] === numarray[2])
                            || (numarray[0] !== numarray[1] && numarray[0] !== numarray[2] && numarray[1] !== numarray[2])) {
                            continue;
                        }
                    } else if (algorithmTypeCode === 'bth3ds') {
                        if (!(numarray[0] !== numarray[1] && numarray[0] !== numarray[2] && numarray[1] !== numarray[2])) {
                            continue;
                        }
                    }

                    bettingCount++;
                }
            }
        }
        return bettingCount;
    };

    private SplitLength(sourceString: string, length) {
        let destString = [];
        let i = 0;
        for (i; i < sourceString.length; i += length) {
            destString.push(sourceString.substr(i, 1));
        }
        if (i > length) {
            destString.push(sourceString.substring(i - length));
        }
        return destString;
    };

    getErrorBettingNumber(value, lotteryTypeCode, playDetail) {
        var bettingCount = 0;
        var errorlist = [];
        var inputstr = value;
        var betNumLength = playDetail.Algorithm.BetNumLength;
        var algorithmCode = playDetail.Algorithm.AlgorithmCode;
        var algorithmTypeCode = playDetail.Algorithm.AlgorithmTypeCode;
        var numlist = [];
        var numindex;
        var num;
        var numarray;
        var sort = false;
        var j;
        if (lotteryTypeCode === "02" || lotteryTypeCode === "08") {
            var splitArr = inputstr.split(/\n|;|,/);
            numlist = [];
            numlist = splitArr || [].find(s => !s);
            bettingCount = 0;
            //排序，判断是否有重复
            var tmparray = [];
            for (numindex = 0; numindex < numlist.length; numindex++) {
                num = numlist[numindex];
                numarray = numlist[numindex].trim().split(" ");
                if (playDetail.Algorithm.TipInfo.indexOf('顺序一致') > 0) {
                    tmparray.push(numarray.join(" "));
                } else {
                    for (var i = 0; i < numarray.length - 1; i++) {
                        for (j = 0; j < numarray.length - 1 - i; j++) {
                            if (parseFloat(numarray[j]) < parseFloat(numarray[j + 1])) {
                                var tmp = numarray[j];
                                numarray[j] = numarray[j + 1];
                                numarray[j + 1] = tmp;
                            }
                        }
                    }
                    tmparray.push(numarray.join(" "));
                }
            }
            numlist = tmparray;

            for (numindex = 0; numindex < numlist.length; numindex++) {
                num = numlist[numindex];
                if (num) {
                    bettingCount++;

                    numarray = numlist[numindex].trim().split(" ");
                    if (numarray.length != betNumLength) {
                        bettingCount = 0;
                        errorlist.push(num);
                        continue;
                    }

                    for (var k = 0; k < numarray.length; k++) {
                        var n = numarray[k];
                        if (n.length != 2 || (parseInt(n) > 11 || parseInt(n) < 1)) {
                            bettingCount = 0;

                            errorlist.push(num); // 号码不在选号范围
                            break;
                        }
                    }

                    outerloop:
                    for (var i = 0; i < numarray.length - 1; i++) {
                        for (j = i + 1; j < numarray.length; j++) {
                            if (numarray[i] == (numarray[j])) {
                                bettingCount = 0;
                                errorlist.push(num); // 有重复号码
                                break outerloop;
                            }
                        }
                    }
                }
                if (errorlist.length >= 10) {
                    throw new Error("号码输入有误，请重新输入");
                }
            }
        }

        else if (lotteryTypeCode == ("04")) {
            numlist = inputstr.replaceAll(" ", "").replaceAll("　", "").split(/[^\d]+/g);
            numindex = 0;
            bettingCount = 0;
            for (numindex = 0; numindex < numlist.length; numindex++) {
                if (numlist[numindex]) {
                    numindex++;
                    bettingCount++;
                    num = numlist[numindex];
                    if (num < 0) {
                        bettingCount = 0;
                        errorlist.push(num); // 输入有误
                    }

                    if (playDetail.AlgorithmCode == ("04006")) {
                        if (numlist[numindex].length != betNumLength * 2) {
                            bettingCount = 0;
                            errorlist.push(num); // 长度有误
                        }
                        numarray = this.SplitLength(numlist[numindex], 2);//numlist[numindex].splitLength(2);
                        outerloop:
                        for (i = 0; i < numarray.length - 1; i++) {
                            for (j = i + 1; j < numarray.length; j++) {
                                if (numarray[i] == (numarray[j])) {
                                    bettingCount = 0;
                                    errorlist.push(num); // 有重复号码
                                    break outerloop;
                                }
                            }
                        }
                        numarray.forEach(s => {
                            if (s.length == 2 && (n > 20 || n < 1)) {
                                bettingCount = 0;
                                errorlist.push(num);
                                return false;
                            }
                        });

                    }
                }
                if (errorlist.length >= 10) {
                    throw new Error("号码输入有误，请重新输入");
                }
            }
        }
        else if (lotteryTypeCode == "07") {
            numlist = inputstr.split(/[^\d]/g);
            var len = numlist.length;
            for (i = 0; i < len; i++) {
                num = numlist[i];
                var regex = new RegExp('^[0-6]{' + betNumLength + '}$');
                if (!regex.test(num)) {
                    errorlist.push(num);
                    continue;
                }
                var first;
                var second;
                if (algorithmTypeCode === "bth2ds") {
                    if (num.length !== 2) {
                        continue;
                    }
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    if (first === second) {
                        errorlist.push(num);
                        continue;
                    };
                } else if (algorithmTypeCode === "bth3ds") {
                    if (num.length !== 3) continue;
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    var third = num.substring(2, 3);
                    if (first === second || second === third || third === first) {
                        errorlist.push(num);
                        continue;
                    };
                } else if (algorithmTypeCode === "th2dxds") {
                    if (num.length !== 3) {
                        continue;
                    }
                    first = num.substring(0, 1);
                    second = num.substring(1, 2);
                    third = num.substring(2, 3);
                    if (first !== second) {
                        errorlist.push(num);
                        continue;
                    };
                    if (first !== second && first !== third && second !== third) {
                        errorlist.push(num);
                        continue;
                    }
                    if (first == second && first == third && second == third) {
                        errorlist.push(num);
                        continue;
                    }

                }

                bettingCount++;
            }
        }
        else {
            numlist = inputstr.split(/[^\d]+/g);
            numindex = 0;
            bettingCount = 0;
            for (numindex = 0; numindex < numlist.length; numindex++) {
                if (numlist[numindex]) {
                    bettingCount++;
                    num = numlist[numindex];
                    if (num < 0) {
                        bettingCount = 0;
                        errorlist.push(num); // 输入有误
                    }

                    if (num.length != betNumLength) {
                        bettingCount = 0;
                        errorlist.push(num); // 长度有误
                    }
                    numarray = this.SplitLength(num, 1);//num.splitLength(1);
                    if ((algorithmTypeCode == ("ZU3DS") && num.length == 3)
                        || (algorithmTypeCode == ("0313") && num.length == 3)) {
                        if ((numarray[0] != (numarray[1]) && numarray[0] != (numarray[2]) && numarray[1] != numarray[2])
                            || (numarray[0] == numarray[1] && numarray[0] == numarray[2])) {
                            bettingCount = 0;
                            errorlist.push(num); // 不是组三的号码
                        }
                        sort = true;
                    } else if ((algorithmTypeCode == ("ZU6DS") && num.length == 3)
                        || (algorithmTypeCode == ("0314") && num.length == 3)) {
                        if (!(numarray[0] != numarray[1] && numarray[0] != numarray[2] && numarray[1] != numarray[2])) {
                            bettingCount = 0;

                            errorlist.push(num); // 不是组六的号码
                        }
                        sort = true;
                    } else if ((algorithmTypeCode == ("0105") && num.length == 3)
                        || (algorithmTypeCode == ("0307") && num.length == 3)) {
                        if (numarray[0] == numarray[1] && numarray[0] == numarray[2]) {
                            bettingCount = 0;

                            errorlist.push(num); // 不是组三或组六的号码
                        }
                        sort = true;
                    } else if ((algorithmTypeCode == ("0111") && num.length == 2)
                        || (algorithmTypeCode == ("ZU2DS") && num.length == 2)) {
                        if (numarray[0] === numarray[1]) {
                            bettingCount = 0;

                            errorlist.push(num); // 不是合法的号码
                        }
                        sort = true;
                    }
                }

                if (algorithmCode == ("03002")
                    || algorithmCode == ("03004")
                    || algorithmCode == ("03007")) {
                    if (numlist[numindex].length != betNumLength) {
                        bettingCount = 0;
                        errorlist.push(num); // 长度有误
                    }
                    if (algorithmCode == ("03007")) {
                        numarray = this.SplitLength(numlist[numindex], 1);//numlist[numindex].splitLength(1);
                        if (numarray[0] == (numarray[1]) && numarray[0] == (numarray[2])) {
                            bettingCount = 0;
                            errorlist.push(num); // 不是组三或组六的号码
                        }
                    }
                }

            }
        }

        var temp = [];
        if (sort) {
            numlist.forEach(s => {
                if (errorlist.indexOf(s) < 0) {
                    temp.push(s.split('').sort().join(''));
                }
            });
        } else {
            numlist.forEach(s => {
                if (errorlist.indexOf(s) < 0) {
                    temp.push(s);
                }
            });
        }
        var err = this.dumpNum(temp);
        errorlist = errorlist.concat(err.err);
        return {
            errorlist: errorlist,
            correct: err.newer
        };
    };

    dumpNum(numlist) {
        var l = numlist.length;
        var unique = {}
            , newer = []
            , err = [];
        for (var i = 0; i < l; i++) {
            if (unique[numlist[i]]) {
                err.push(numlist[i]);
                numlist[i] = undefined;
            } else {
                newer.push(numlist[i]);
            }
            unique[numlist[i]] = 1;
        }
        return { newer: newer, err: err };
    };

    private getStringPadLeft(str: string, len, pad) {
        var ss = "";
        for (var i = 0; i < len - str.length; i++) {
            if (str.length < len) {
                ss += pad;
            }
        }
        str = ss + str;
        return str;
    }

    private GetSSCLotteryBetCount(dataSel, checkedlength, algorithmTypeCode, betNumLength, isrx) {
        var nums = 0;
        var tmp_nums;
        var h;
        var s;
        switch (algorithmTypeCode) {
            case "LONGHU":
                for (var l = 0; l < dataSel.length; l++) {
                    nums += dataSel[l].length;
                }
                break;
            case "ZH5":
            case "ZH4":
            case "ZH3":
                tmp_nums = 1;
                for (var i = 0; i <= betNumLength - 1; i++) {
                    if (dataSel[i].length == 0) {
                        tmp_nums = 0;
                        break;
                    }
                    tmp_nums *= dataSel[i].length;
                }
                nums = tmp_nums * parseInt(algorithmTypeCode.charAt(algorithmTypeCode.length - 1));
                break;
            case "WXZU120":
                s = dataSel[0].length;
                if (s > 4) {
                    nums = MathAlgorithm.Combination(s, 5);
                }
                break;
            case "WXZU60":
                tmp_nums = 0;
                if (dataSel[0].length >= 1 && dataSel[1].length >= 3) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length;
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 1) * MathAlgorithm.Combination(dataSel[1].length, 3);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 1) * MathAlgorithm.Combination(dataSel[1].length - 1, 2);
                    }
                }
                nums = tmp_nums;
                break;
            case "WXZU30":
                tmp_nums = 0;
                if (dataSel[0].length >= 2 && dataSel[1].length >= 1) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 2) * MathAlgorithm.Combination(dataSel[1].length, 1);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 2) * MathAlgorithm.Combination(2, 1);
                        if (dataSel[0].length - h > 0) {
                            tmp_nums -= MathAlgorithm.Combination(h, 1) * MathAlgorithm.Combination(dataSel[0].length - h, 1);
                        }
                    }
                }
                nums = tmp_nums;
                break;
            case "WXZU20":
                tmp_nums = 0;
                if (dataSel[0].length >= 1 && dataSel[1].length >= 2) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 1) * MathAlgorithm.Combination(dataSel[1].length, 2);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 1) * MathAlgorithm.Combination(dataSel[1].length - 1, 1);
                    }
                }
                nums = tmp_nums;
                break;
            case "WXZU10":
            case "WXZU5":
                tmp_nums = 0;
                if (dataSel[0].length >= 1 && dataSel[1].length >= 1) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 1) * MathAlgorithm.Combination(dataSel[1].length, 1);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 1);
                    }
                }
                nums = tmp_nums;
                break;
            case "SXZU24":
                s = dataSel[0].length;
                if (s > 3) {
                    nums += MathAlgorithm.Combination(s, 4);
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 4);
                }
                break;
            case "SXZU6":
                if (dataSel[0].length >= 2) {
                    nums += MathAlgorithm.Combination(dataSel[0].length, 2);
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 4);
                }
                break;
            case "SXZU12":
                if (dataSel[0].length >= 1 && dataSel[1].length >= 2) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 1) * MathAlgorithm.Combination(dataSel[1].length, 2);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 1) * MathAlgorithm.Combination(dataSel[1].length - 1, 1);
                    }
                    nums += tmp_nums;
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 4);
                }
                break;
            case "SXZU4":
                if (dataSel[0].length >= 1 && dataSel[1].length >= 1) {
                    h = dataSel[0].filter(s => dataSel[1].indexOf(s) > -1).length
                    tmp_nums = MathAlgorithm.Combination(dataSel[0].length, 1) * MathAlgorithm.Combination(dataSel[1].length, 1);
                    if (h > 0) {
                        tmp_nums -= MathAlgorithm.Combination(h, 1);
                    }
                    nums += tmp_nums;
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 4);
                }
                break;
            case "0104": // 组六复式
                if (dataSel[0].length < betNumLength) {
                    nums = 0;
                } else {
                    nums = MathAlgorithm.Combination(dataSel[0].length, betNumLength);
                }

                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 3);
                }

                break;
            case "0110": // 组二复式
                if (dataSel[0].length < betNumLength) {
                    nums = 0;
                } else {
                    nums = MathAlgorithm.Combination(dataSel[0].length, betNumLength);
                }

                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 2);
                }

                break;
            case "BDW1":
                if (dataSel[0].length < 2) {
                    nums = 0;
                } else {
                    nums = MathAlgorithm.Combination(dataSel[0].length, 2);
                }
                break;
            case "BDW2":
                if (dataSel[0].length < 3) {
                    nums = 0;
                } else {
                    nums = MathAlgorithm.Combination(dataSel[0].length, 3);
                }
                break;
            case "0103": // 组三复式
                if (dataSel[0].length < 2) {
                    nums = 0;
                } else {
                    nums = MathAlgorithm.Arrangement1(dataSel[0].length, 2);
                }

                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 3);
                }
                break;
            case "0107": // 直选和值
                tmp_nums = 0;
                if (dataSel[0].length > 0) {
                    dataSel[0].forEach(s => {
                        if (betNumLength == 2) {
                            tmp_nums += MathAlgorithm.GetNumCombinationCount2(s);
                        } else if (betNumLength == 3) {
                            tmp_nums += MathAlgorithm.GetNumCombinationCount3(s);
                        }
                    });
                    nums += tmp_nums;
                } else {
                    nums = 0;
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, betNumLength);
                }
                break;
            case "0108": // 三星组选和值
                tmp_nums = 0;
                if (dataSel[0].length > 0) {
                    dataSel[0].forEach(s => {
                        tmp_nums += MathAlgorithm.GetNumCombinationNoSameCount(s);
                    });
                    nums += tmp_nums;
                } else {
                    nums = 0;
                }

                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, betNumLength);
                }
                break;
            case "ZUHZ2":
                tmp_nums = 0;
                if (dataSel[0].length > 0) {
                    dataSel[0].forEach(s => {
                        tmp_nums += MathAlgorithm.GetNumCombinationCompose(s);
                    });
                    nums += tmp_nums;
                } else {
                    nums = 0;
                }
                if (isrx == 1) {
                    nums *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, 2);
                }
                break;
            case "0106":
            case "0112":
            case "HQDWD":
                dataSel.forEach(s => {
                    nums += s.length;
                });
                break;
            case "0113":
                tmp_nums = 1;
                dataSel.forEach(s => {
                    tmp_nums *= s.length;
                });
                nums += tmp_nums;
                break;
            case "ZXKD":
                var cc;

                if (betNumLength == 2) {
                    cc = {
                        0: 10,
                        1: 18,
                        2: 16,
                        3: 14,
                        4: 12,
                        5: 10,
                        6: 8,
                        7: 6,
                        8: 4,
                        9: 2
                    };
                } else if (betNumLength == 3) {
                    cc = {
                        0: 10,
                        1: 54,
                        2: 96,
                        3: 126,
                        4: 144,
                        5: 150,
                        6: 144,
                        7: 126,
                        8: 96,
                        9: 54
                    };
                }

                var length = dataSel[0].length;
                for (var k = 0; k < length; k++) {
                    nums += cc[parseInt(dataSel[0][k], 10)];
                }
                break;
            case "ZUBD":
                if (betNumLength == 2) {
                    nums = dataSel[0].length * 9;
                } else {
                    nums = dataSel[0].length * 54;
                }
                break;
            case "RXZXFS":
                var aCodePosition = [];
                for (i = 0; i <= 4; i++) {
                    var codelen = dataSel[i].length;
                    if (codelen > 0) {
                        aCodePosition.push(i);
                    }
                }
                var sellen = betNumLength;
                var aPositionCombo = MathAlgorithm.GetCombination(aCodePosition, sellen);
                var iComboLen = aPositionCombo.length;
                var aCombo = [];
                var iLen = 0;
                var tmpNums = 1;
                for (var j = 0; j < iComboLen; j++) {
                    aCombo = aPositionCombo[j].split(",");
                    iLen = aCombo.length;
                    tmpNums = 1;
                    for (h = 0; h < iLen; h++) {
                        tmpNums *= dataSel[aCombo[h]].length;
                    }
                    nums += tmpNums;
                }
                break;
            default:
                tmp_nums = 1;
                dataSel.forEach(s => {
                    tmp_nums *= s.length;
                });
                nums += tmp_nums;
                break;
        }

        return nums;
    };

    private Get5in11BetCount(data, checkedlength, algorithmTypeCode, betNumLength) {
        var num = 0, i, j;
        switch (algorithmTypeCode) {
            case "0203":
            case "0208":
                data.forEach(s => {
                    num += s.length;
                });
                break;
            case "0204":
                if (data.length < betNumLength) {
                    num = 0;
                } else {
                    if (betNumLength == 2) {
                        for (i = 0; i < data[0].length; i++) {
                            for (j = 0; j < data[1].length; j++) {
                                if (data[0][i] != data[1][j]) {
                                    num++;
                                }
                            }
                        }
                    } else if (betNumLength == 3) {
                        for (i = 0; i < data[0].length; i++) {
                            for (j = 0; j < data[1].length; j++) {
                                for (k = 0; k < data[2].length; k++) {
                                    if (data[0][i] != data[1][j] && data[0][i] != data[2][k] && data[1][j] != data[2][k]) {
                                        num++;
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case "DT":
            case "RXDT":
                var danlen = data[0].length;
                var tuolen = data[1].length;
                var sellen = betNumLength;
                if (danlen < 1 || tuolen < 1 || danlen > sellen) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(tuolen, sellen - danlen);
                }
                break;
            case "DDS":
            case "CZW":
                for (var k = 0; k < data.length; k++) {
                    num += data[k].length;
                }
                break;
            case "0206":
                if (data[0].length < betNumLength) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(data[0].length, betNumLength);
                }
                break;
            default:
                var checked = 0;
                data.forEach(s => {
                    checked += s.length;
                });
                if (checked >= betNumLength) {
                    num = MathAlgorithm.Combination(checked, betNumLength);
                }
                break;
        }
        return num;
    };

    private GetLowFrequencyBetCount(data, checkedlength, algorithmTypeCode, betNumLength) {
        var num = 0;
        switch (algorithmTypeCode) {
            case "0303":
                num = 1;
                for (var j = 0; j < data.length; j++) {
                    num *= data[j].length;
                }
                break;
            case "0305":
                if (data[0].length >= 2) {
                    num = MathAlgorithm.Arrangement1(data[0].length, 2);
                }
                break;
            case "0306":
                if (data[0].length < betNumLength) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(data[0].length, betNumLength);
                }
                break;
            case "0308":
                num = 0;
                if (data[0].length > 0) {
                    data[0].forEach(s => {
                        num += MathAlgorithm.GetNumCombinationCount3(s);
                    });
                }
                break;
            case "0309":
                if (data[0].length > 0) {
                    data[0].forEach(s => {
                        num += MathAlgorithm.GetNumCombinationNoSameCount(s);
                    });
                }
                break;
            case "0310":
            case "0311":
                data.forEach(s => {
                    num += s.length;
                });
                break;
            case "0312":
                if (data[0].length >= 2) {
                    num = MathAlgorithm.Combination(data[0].length, 2);
                }
                break;
            case "ZU2FS":
                if (data[0].length < 2) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(data[0].length, 2);
                }
                break;
            default:
                if (data.length === betNumLength) {
                    num = 1;
                    for (var j = 0; j < data.length; j++) {
                        num *= data[j].length;
                    }
                }
                break;
        }

        return num;
    };

    private GetKuai3BetCount(dataSel, checkedlength, algorithmTypeCode, betNumLength) {
        var num = 0;
        switch (algorithmTypeCode) {
            case "0701":
            case "0708":
            case "0702":
            case "0703":
            case "0704":
                num = dataSel[0].length;
                break;
            case "0705":
                num = dataSel[0].length * dataSel[1].length;
                break;
            case "0706":
                if (dataSel[0].length < 3) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(dataSel[0].length, 3);
                }
                break;
            case "0707":
                if (dataSel[0].length < 2) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(dataSel[0].length, 2);
                }
                break;
            case "bthdt":
                var danlen = dataSel[0].length;
                var tuolen = dataSel[1].length;
                var sellen = betNumLength;
                if (danlen < 1 || tuolen < 1 || danlen >= sellen) {
                    num = 0;
                } else {
                    num = MathAlgorithm.Combination(tuolen, sellen - danlen);
                }
                break;
            case "bth3hz":
                var cc = { 6: 1, 7: 1, 8: 2, 9: 3, 10: 3, 11: 3, 12: 3, 13: 2, 14: 1, 15: 1 };
                var s = dataSel[0].length;
                if (s > 0) {
                    for (var j = 0; j < s; j++) {
                        num += cc[parseInt(dataSel[0][j], 10)];
                    }
                }
                break;
            default:
                num = 0;
                break;
        }
        return num;
    };

    private GetPk10BetCount(dataSel, checkedlength, algorithmTypeCode, betNumLength) {
        console.log(dataSel)
        var num = 0;
        var j;
        var k;
        switch (algorithmTypeCode) {
            case "PK10GYJ":
                for (j = 0; j < dataSel[0].length; j++) {
                    for (k = 0; k < dataSel[1].length; k++) {
                        if (dataSel[0][j] !== dataSel[1][k]) {
                            num++;
                        }
                    }
                }
                break;
            case "PK10QSM":
                for (j = 0; j < dataSel[0].length; j++) {
                    for (k = 0; k < dataSel[1].length; k++) {
                        for (var l = 0; l < dataSel[2].length; l++) {
                            if (dataSel[0][j] !== dataSel[1][k] && dataSel[0][j] !== dataSel[2][l] && dataSel[1][k] !== dataSel[2][l]) {
                                num++;
                            }
                        }
                    }
                }
                break;
            case "PK10Four":
                for (j = 0; j < dataSel[0].length; j++) {
                    for (k = 0; k < dataSel[1].length; k++) {
                        for (var l = 0; l < dataSel[2].length; l++) {
                            for (let e = 0; e < dataSel[3].length; e++) {
                                if (dataSel[0][j] !== dataSel[1][k] && dataSel[0][j] !== dataSel[2][l] && dataSel[0][j] !== dataSel[3][e] && dataSel[1][k] !== dataSel[2][l] && dataSel[1][k] !== dataSel[3][e] && dataSel[2][l] !== dataSel[3][e]) {
                                    num++;
                                }

                            }

                        }

                    }
                }
                break;
            case "PK10Five":
                for (j = 0; j < dataSel[0].length; j++) {
                    for (k = 0; k < dataSel[1].length; k++) {
                        for (var l = 0; l < dataSel[2].length; l++) {
                            for (let e = 0; e < dataSel[3].length; e++) {
                                for (let h = 0; h < dataSel[4].length; h++) {
                                    if (dataSel[0][j] !== dataSel[1][k] && dataSel[0][j] !== dataSel[2][l] && dataSel[0][j] !== dataSel[3][e] && dataSel[0][j] !== dataSel[4][h] && dataSel[1][k] !== dataSel[2][l] && dataSel[1][k] !== dataSel[3][e] && dataSel[1][k] !== dataSel[4][h] && dataSel[2][l] !== dataSel[3][e] && dataSel[2][l] !== dataSel[4][h] && dataSel[3][e] !== dataSel[4][h]) {
                                        num++;
                                    }

                                }
                            }
                        }

                    }
                }
                break;
            case "PK10QDWD1":
            case "PK10QDWD2":
            case "PK10DX":
            case "PK10DS":

                dataSel.forEach(s => {
                    num += s.length;
                });
                break;
            default:
                num = 1;
                dataSel.forEach(s => {
                    num *= s.length;
                });
                break;
        }
        return num;
    };

}


export class MathAlgorithm {
    static Combination(c, b) {
        b = parseInt(b);
        c = parseInt(c);
        if (b < 0 || c < 0) {
            return;
        }
        if (b == 0 || c == 0) {
            return 1;
        }
        if (b > c) {
            return 0;
        }
        if (b > c / 2) {
            b = c - b;
        }
        var a = 0;
        for (var i = c; i >= (c - b + 1); i--) {
            a += Math.log(i);
        }
        for (i = b; i >= 1; i--) {
            a -= Math.log(i);
        }
        a = Math.exp(a);
        return Math.round(a);
    };

    static Arrangement1(n, r) {
        if (r > n || r <= 0 || n <= 0) return 0;
        var t = 1;
        var i = n;

        while (i != n - r) {
            t *= i;
            --i;
        }
        return t;
    };

    static GetNumCombinationCount2(sum) {
        var num = 0;

        for (var i = 0; i < 10; i++) {
            for (var j = 0; j < 10; j++) {
                if (i + j == sum) {
                    num++;
                }
            }
        }
        return num;
    };

    static GetNumCombinationCount3(sum) {
        var num = 0;

        for (var i = 0; i < 10; i++) {
            for (var j = 0; j < 10; j++) {
                for (var k = 0; k < 10; k++) {
                    if (i + j + k == sum) {
                        num++;
                    }
                }
            }
        }
        return num;
    };

    static GetNumCombinationNoSameCount(sum) {
        var num = 0;
        var i;
        var j;
        for (i = 0; i < 10; i++) {
            for (j = 0; j < 10; j++) {
                if (i + i + j == sum && i != j) {
                    num++;
                }
            }
        }
        for (i = 0; i < 10; i++) {
            for (j = i + 1; j < 10; j++) {
                for (var k = j + 1; k < 10; k++) {
                    if (i + j + k == sum && (i != j && i != k && j != k)) {
                        num++;
                    }
                }
            }
        }
        return num;
    };

    static GetNumCombinationCompose(sum) {
        var num = 0;
        for (var i = 0; i < sum / 2; i++) {
            for (var j = 1; j < 10; j++) {
                if (i + j == sum && i != j) {
                    num++;
                }
            }
        }
        return num;
    };

    static GetCombination(o, c) {
        var l = o.length;
        var r = new Array();
        if (c > l) {
            return r
        }
        if (c == 1) {
            return o
        }
        if (l == c) {
            r[0] = o.join(",");
            return r
        }
        var a = "";
        var b = "";
        var s = "";
        for (var g = 0; g < c; g++) {
            a += "1";
            b += "1"
        }
        for (var e = 0; e < l - c; e++) {
            a += "0"
        }
        for (var d = 0; d < c; d++) {
            s += o[d] + ","
        }
        r[0] = s.substr(0, s.length - 1);
        var h = 1;
        s = "";
        while (a.substr(a.length - c, c) != b) {
            a = this.movestring(a);
            for (var d = 0; d < l; d++) {
                if (a.substr(d, 1) == "1") {
                    s += o[d] + ","
                }
            }
            r[h] = s.substr(0, s.length - 1);
            s = "";
            h++
        }
        return r
    };

    private static movestring(a) {
        var h = "";
        var k = "01";
        var b = "";
        var f = "";
        var j = "";
        var g = false;
        var c = false;
        for (var e = 0; e < a.length; e++) {
            if (g == false) {
                h += a.substr(e, 1)
            }
            if (g == false && a.substr(e, 1) == "1") {
                c = true
            } else {
                if (g == false && c == true && a.substr(e, 1) == "0") {
                    g = true
                } else {
                    if (g == true) {
                        b += a.substr(e, 1)
                    }
                }
            }
        }
        h = h.substr(0, h.length - 2);
        for (var d = 0; d < h.length; d++) {
            if (h.substr(d, 1) == "1") {
                f += h.substr(d, 1)
            } else {
                if (h.substr(d, 1) == "0") {
                    j += h.substr(d, 1)
                }
            }
        }
        h = f + j;
        return h + k + b
    };



}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/bettingorder.helper.ts